import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicModal from '../../Components/Modal_Basic';
import CkeckingForm from '../../Components/CkeckingForm';
import BasicButton from '../../Components/Button_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { useSelector, useDispatch } from 'react-redux';

function BM10110(props) {
    const gridRef = React.useRef();
    //그리드 컬럼
    const columnDefs = [
        {
            field: 'userId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserId' && f.lanType === 'COL')[0].lanName
                    : '', //사용자ID
            minWidth: 150,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            editable: false,
        },
        {
            field: 'userNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserNm' && f.lanType === 'COL')[0].lanName
                    : '', //사용자명
            editable: false,
        },
        {
            field: 'barcodeLocation',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserNm' && f.lanType === 'COL')[0].lanName
                    : '', //바코드위치
            editable: false,
            hide: true,
        },
        {
            field: 'barcodeLocationNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BarcodeLocation' && f.lanType === 'COL')[0].lanName
                    : '', //바코드위치
            minWidth: 150,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: props.inputs.comboBarcode,
                default: props.inputs.comboValue,
            },
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
        },
        {
            field: 'ip',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Ip' && f.lanType === 'COL')[0].lanName
                    : '', //IP
            editable: false,
        },
        {
            field: 'port',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Port' && f.lanType === 'COL')[0].lanName
                    : '', //PORT
            editable: false,
        },
        // {
        //   field: "createDate",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_CreateDate" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //생성일자
        //   editable: false,
        // },
        // {
        //   field: "createId",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_CreateId" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //생성자
        //   editable: false,
        // },
        // {
        //   field: "updateDate",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_UpdateDate" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //수정일자
        //   editable: false,
        // },
        // {
        //   field: "updateId",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_UpdateId" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //수정자
        //   editable: false,
        // },
    ];
    const [modalToggle, setModalToggle] = React.useState(false);

    React.useEffect(() => {
        document.title = '통신관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>통신관리</strong>" +
            '</h1>';
        let a = props.rowData;
        if (props.checkInputs.result) {
            gridRef.current.api.setRowData([
                {
                    processCd: props.checkInputs.processCd,
                    processNm: props.checkInputs.comboProcessCd.filter(
                        (target) => target.value == props.checkInputs.processCd
                    )[0].name,
                    machineCd: props.checkInputs.machineCd,
                    newYn: 'Y',
                },
                ...props.rowData,
            ]);
            props.setSaveData([
                ...props.saveData,
                {
                    processCd: props.checkInputs.processCd,
                    machineCd: props.checkInputs.machineCd,
                },
            ]);
            props.setCheckInputs({
                ...props.checkInputs,
                processCd: '',
                machineCd: '',
                result: false,
            });
        }
    }, [props.checkInputs.result]);

    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                {/* 그리드 버튼 */}
                <AuthGroupButton
                    pageName="BM10110"
                    target="G01"
                    selectFunc={() => {
                        props.Init();
                    }}
                    refreshNone="none"
                    addFunc={() => setModalToggle(true)}
                    saveFunc={() => props.SaveConfirm()}
                    deleteFunc={() => props.DeleteConfirm()}
                />
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                {/* 그리드 */}
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                        editable: true,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    rowData={props.rowData}
                    rowSelection="multiple"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData);
                    }}
                    getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                />
            </div>
            {/* 코드 체크 팝업 */}
            {modalToggle && (
                <BasicModal
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_CodeManagement' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : '' //코드관리
                    }
                    onClose={() => setModalToggle(false)}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0].lanName
                            : '' //검사
                    }
                    execLogic={() => props.CheckKeys()}
                >
                    <CkeckingForm
                        datas={[
                            {
                                type: 'combo',
                                combos: props.checkInputs.comboProcessCd,
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Dia_ProcessCd' && f.lanType === 'DIALOG'
                                          )[0].lanName
                                        : '', //공정코드
                                value: props.checkInputs.processCd,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        processCd: e,
                                    });
                                },
                            },
                            {
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Col_MachineCd' && f.lanType === 'COL'
                                          )[0].lanName
                                        : '', //설비코드
                                value: props.checkInputs.machineCd,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        machineCd: e.target.value,
                                    });
                                },
                            },
                        ]}
                    />
                </BasicModal>
            )}
        </div>
    );
}

export default BM10110;
